import { Controller } from "@hotwired/stimulus";
import "./component.scss";

export default class extends Controller {
  static values = { markAsReadUrl: String };

  // The entry links straight to its target (see component.rb#target_path), so
  // the read state goes out on its own. keepalive lets the request finish even
  // when the native app reloads the page for the visit.
  markAsRead() {
    const token = document.querySelector('meta[name="csrf-token"]')?.content;

    fetch(this.markAsReadUrlValue, {
      method: "POST",
      headers: { Accept: "application/json", ...(token && { "X-CSRF-Token": token }) },
      credentials: "same-origin",
      keepalive: true,
    }).catch(() => {
      // The notification stays unread; the next tap tries again.
    });
  }
}
